window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) { }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Send the CSRF token via the X-CSRF-TOKEN header sourced from the page's
 * meta tag. The default XSRF-TOKEN cookie expires at the session lifetime
 * (120 min), so the auto-logout POST fired at that exact boundary would 419
 * and never clear the single-device lock. The meta token lives for the page's
 * lifetime and validates as long as the session is still alive.
 */
const csrfToken = document.head.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
}

window.axios.interceptors.response.use(
    function (response) {
        // Return the response if it's successful
        return response;
    },
    function (error) {
        // Destructure the error object to get necessary properties
        const { config, response } = error;

        // Skip the global snackbar for (a) cancelled requests — intentional,
        // e.g. one superseded by a newer one — and (b) requests that opt out via
        // `skipGlobalError` because the caller surfaces the error inline itself.
        if (!window.axios.isCancel(error) && !(config && config.skipGlobalError)) {
            Vue.prototype.$eventBus.$emit('showSnackbar', response)
        }

        // Reject the promise with the error object
        return Promise.reject(error);
    }
);


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';